kv.controller('TargetListCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
	var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
	vm.primaryKey = 'target_id';
	vm.entity = 'target';

	vm.count = {
		total: 0,
		showing: 0
	};

	vm.getInfinitScroll({
		params: {
			action: 'target'
		},
		url: "target"
	});

	vm.addEditEntity = function (target_id) {
		vm.openModal({
			templateUrl: "target-edit",
			controller: 'targetEditCtrl',
			controllerAs: 'vm',
			size: 'lg',
			resolve: {
				params: function () {
					return {
                        target_id: target_id,
                    };
				},
				saveCallback: function () {
					vm.infinitScroll.search.refresh++;
				},
			}
		}).then(response => {
			if (!response) return;
			window.location = "/target";
		});
	};

	vm.delete = function ($index) {
		vm.confirm('DELETE', vm.trans('LANG.ARE_YOU_SURE_DELETE')).then(response => {
			if (response !== 'ok') return;
			$http.delete("target/" + vm.infinitScroll.items[$index]['target_id']).then(function () {
				vm.infinitScroll.items.splice($index, 1);
			});
		});
	};
	return vm;
});

